<template>
  <MessageLayout :is-archived="isArchived" :message="message">
    <h6 slot="header" class="message__title">
      Votre ticket est
      <span :style="{ color: message.dominant_color }">
        en cours de traitement
      </span>
    </h6>

    <!-- eslint-disable vue/no-v-html -->
    <div v-if="message.data.text" slot="content" class="message__text" v-html="nl2br(message.data.text)" />
    <!-- eslint-enable vue/no-v-html -->
  </MessageLayout>
</template>

<script>
import Mixin from './mixin'

export default {
  mixins: [Mixin],
  props: {
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('dominant_color') &&
        message.hasOwnProperty('data') &&
        message.data.hasOwnProperty('text') &&
        true
      ,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";

.message__title {
  @include font-family__oswald;
  margin: 0;
}
.message__text {
  padding: 1rem;
}
</style>
